// extracted by mini-css-extract-plugin
module.exports = {"trailer":"f-","imgWrapper":"f_","thumbnail":"ha","isRental":"hb","playWrapper":"hc","playImg":"hd","title":"he","iconWrapper":"hf","navArrow":"hh"};